/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React from "react";

import { FormElement } from "../../../shared/FormModel/FormElement";
import { FORM_EL_TYPE } from "../../../shared/FormModel/FormElementTypes";
import { FormSectionGroupComponent } from "./FormSectionGroupComponent";
import { FormSectionGroup } from "../../../shared/FormModel/elements/FormSectionGroup";
import { FormSectionComponent } from "./FormSectionComponent";
import { FormSection } from "../../../shared/FormModel/elements/FormSection";
import { FormRowComponent } from "./FormRowComponent";
import { FormRow } from "../../../shared/FormModel/elements/FormRow";
import { FormFieldTextComponent } from "./FormFieldTextComponent";
import { FormFieldText } from "../../../shared/FormModel/elements/FormFieldText";
import { FormFieldSelectComponent } from "./FormFieldSelectComponent";
import { FormFieldSelect } from "../../../shared/FormModel/elements/FormFieldSelect";
import { FormFieldLabel } from "../../../shared/FormModel/elements/FormFieldLabel";
import { FormFieldLabelComponent } from "./FormFieldLabelComponent";
import { FormHTMLContentComponent } from "./FormHTMLContentComponent";
import { FormHTMLContent } from "../../../shared/FormModel/elements/FormHTMLContent";
import { FormRowListComponent } from "./FormRowListComponent";
import { FormRowList } from "../../../shared/FormModel/elements/FormRowList";

/**
 * Renders form element component based on it's type.
 *
 * @param element Form element
 */
export function renderFormElement(element: FormElement<any>) {

	switch(element.getType()) {

		case FORM_EL_TYPE.SECTION_GROUP:
			return <FormSectionGroupComponent key={element.getUid()} element={element as FormSectionGroup} />;

		case FORM_EL_TYPE.SECTION:
			return <FormSectionComponent key={element.getUid()} element={element as FormSection} />;

		case FORM_EL_TYPE.ROW:
			return <FormRowComponent key={element.getUid()} element={element as FormRow} />;

		case FORM_EL_TYPE.ROW_LIST:
			return <FormRowListComponent key={element.getUid()} element={element as FormRowList} />;

		case FORM_EL_TYPE.FIELD_TEXT:
			return <FormFieldTextComponent key={element.getUid()} element={element as FormFieldText} />;

		case FORM_EL_TYPE.FIELD_SELECT:
			return <FormFieldSelectComponent key={element.getUid()} element={element as FormFieldSelect} />;

		case FORM_EL_TYPE.FIELD_LABEL:
			return <FormFieldLabelComponent key={element.getUid()} element={element as FormFieldLabel} />;

		case FORM_EL_TYPE.HTML_CONTENT:
			return <FormHTMLContentComponent key={element.getUid()} element={element as FormHTMLContent} />;

		case FORM_EL_TYPE.HIDDEN_EXPRESSION:
			return null;

		default:
			return <span>Unkown form element type '{String(element.getType())}'.</span>

	}

}

/**
 * Renders a list of form elements
 *
 * @param elements Element list
 */
export function renderFormElementList(elements: Array<FormElement<any>>) {

	return elements.map((el) => renderFormElement(el));

}